import React from 'react';
import Navigation from '../components/Navigation';
import BackToTop from '../components/BackToTop';
import { useTheme } from '../contexts/ThemeContext';

const About = () => {
  const { isDarkMode, toggleDarkMode } = useTheme();

  return (
    <div className={`min-h-screen ${isDarkMode ? 'dark' : ''} bg-white dark:bg-neutral-900 transition-colors duration-500`}>
      <Navigation isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />

      <main className="pt-32 pb-20 px-6 max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          
          {/* Image Placeholder */}
          <div className="relative aspect-[3/4] w-full bg-neutral-200 dark:bg-neutral-800 rounded-lg overflow-hidden shadow-xl">
            <div className="absolute inset-0 flex items-center justify-center text-neutral-400 dark:text-neutral-500">
              <span className="text-lg uppercase tracking-widest">Artist Portrait</span>
            </div>
            {/* <img src="/path/to/artist-image.jpg" alt="EL Ceballos" className="object-cover w-full h-full" /> */}
          </div>

          {/* Text Content */}
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-6 dark:text-white tracking-tight">
                About the Artist
              </h1>
              <div className="h-1 w-20 bg-neutral-900 dark:bg-white mb-8"></div>
            </div>

            <div className="space-y-6 text-lg leading-relaxed text-neutral-700 dark:text-neutral-300">
              <p>
                My creative process centers on building environments that encourage viewers to slow down and notice often-overlooked details. Blending analog and digital tools—oil paint, camera, projection, and sound—I explore the emotional resonance of space.
              </p>
              
              <p>
                Drawing from color theory, psychology, and the history of immersive art, I create installations that are part experiment, part meditation. My goal is to craft experiences that invite you to explore how your identity and emotional landscape are shaped by the spaces you inhabit—work that is as much about feeling as it is about seeing.
              </p>

              <div className="pt-4 border-t border-neutral-200 dark:border-neutral-700">
                <p className="italic text-base opacity-90">
                  My practice is deeply rooted in my background as a professionally trained chef. Years spent in high-pressure kitchens and event spaces instilled in me a meticulous attention to detail. In that world, every element—lighting, scent, presentation—was calibrated to shape a guest's experience. I bring that same discipline and sensory awareness to my art, approaching each installation with the rigor and intentionality required to create truly immersive environments.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <BackToTop />
    </div>
  );
};

export default About;